import { withHandledHttpFailure } from '~/utils/axiosError'

export const state = () => ({
	filterCriteria: null
})

export const mutations = {
	setFilterCriteria: (state, data) => (state.filterCriteria = data)
}

export const actions = {
	async fetch({ commit }, { throwOnError = false } = {}) {
		const filterCriteriaRequest = throwOnError
			? this.$axios.$get('/filter-criteria', {
					__skipGlobalErrorToast: true
			  })
			: this.$axios.$get('/filter-criteria')
		const request = filterCriteriaRequest.then(data => {
			commit('setFilterCriteria', data)
			return data
		})

		return throwOnError ? request : withHandledHttpFailure(request)
	},

	async needFilterCriteria({ dispatch, state }, options = {}) {
		if (!state.filterCriteria) {
			await dispatch('fetch', options)
		}

		return state.filterCriteria
	}
}
